import styled from '@emotion/styled';
// --- external imports ------

import Asset from '../BaseAssets';
import { PointerCursor } from 'Cursors';
// --- parent imports ------

function getBgColor({ isSelected }) {
	return isSelected ? 'rgba(0,0,0,0.2)' : 'transparent';
}

export const ListItemContainer = styled(Asset.TextContainer)`
	display: block;
	position: relative;
	width: 100%;
	top: 0;
	background-color: ${getBgColor};
	${PointerCursor};
	
	& > * {
		font-family: "KG Corner of the Sky";
	}
`;

export const ListItemText = styled(Asset.Text)`
	left: 1.07em;
	top: 1.07em;
	line-height: 1.6em;
	font-family: "KG Corner of the Sky";
	color: #1f261f;
`;

export const ProfileImg = styled(Asset.Img)`
	right: 0.79em;
	top: 1.15em;
	left: unset;
`;
